var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 50,
    viewBox: "0 0 39 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6803 50H2.04918C1.50589 49.9994 0.985017 49.7833 0.60085 49.3991C0.216683 49.015 0.000596639 48.4941 0 47.9508V2.04918C0.000596639 1.50589 0.216683 0.985017 0.60085 0.60085C0.985017 0.216683 1.50589 0.000596639 2.04918 0H36.6803C37.2236 0.000596639 37.7445 0.216683 38.1287 0.60085C38.5128 0.985017 38.7289 1.50589 38.7295 2.04918V47.9508C38.7289 48.4941 38.5128 49.015 38.1287 49.3991C37.7445 49.7833 37.2236 49.9994 36.6803 50ZM2.04918 0.819672C1.72319 0.819998 1.41065 0.949639 1.18015 1.18015C0.949639 1.41065 0.819998 1.72319 0.819672 2.04918V47.9508C0.819998 48.2768 0.949639 48.5893 1.18015 48.8199C1.41065 49.0504 1.72319 49.18 2.04918 49.1803H36.6803C37.0063 49.18 37.3189 49.0504 37.5494 48.8199C37.7799 48.5893 37.9095 48.2768 37.9098 47.9508V2.04918C37.9095 1.72319 37.7799 1.41065 37.5494 1.18015C37.3189 0.949639 37.0063 0.819998 36.6803 0.819672H2.04918Z",
    fill: "#3762CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleInfo);
export default __webpack_public_path__ + "static/media/VehicleInfo.a54a867c869512f6a1a84463a23debd6.svg";
export { ForwardRef as ReactComponent };